import React from 'react';
import TaskStatsSection from "../TaskStatsSection/TaskStatsSection";

const TransferStatsSection = ({ title, tasks, reassignCount, prefix }) => {
    const pourcentageNiv2 = Math.round((Number(tasks.niv2_today) + Number(reassignCount)) / Number(tasks.task_today) * 100);

    return (
        <div className={'row'}>
            <p className={'outer-title mt-3 ps-0'}>{title}</p>
            <div className={'col-4 mt-3 ps-0'}>
                <p className={'box-card p-3'}>
                    <span className={'f-12'}>{prefix}_NIV2<br/> crées aujourd'hui</span>
                    <br/>
                    <span className={'font-white f-26'}>{tasks.niv2_today + reassignCount}</span>
                    <span className={'f-12'}> soit {pourcentageNiv2 > 0 ? pourcentageNiv2 : '0'}%</span>
                </p>
            </div>
            <div className={'col-4 mt-3'}>
                <p className={'box-card p-3'}>
                    <span className={'f-12'}>{prefix}_NIV2<br/> crées aujourd'hui automatiquement</span>
                    <br/>
                    <span className={'font-white f-26'}>{tasks.niv2_today}</span>
                </p>
            </div>
            <div className={'col-4 mt-3 pe-0'}>
                <p className={'box-card p-3'}>
                    <span className={'f-12'}>{prefix}_NIV2<br/> crées aujourd'hui manuellement</span>
                    <br/>
                    <span className={'font-white f-26'}>{reassignCount}</span>
                </p>
            </div>
        </div>
    );
};
export default TransferStatsSection;